import { Box, Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

export default function ConfirmCloseViewOrder(props) {
  const { onCloseModal, onExitAndSaveOrder, onExitWithoutSave } = props;
  const onCancelClose = () => onCloseModal();
  const onSave = () => onExitAndSaveOrder();
  const onExit = () => onExitWithoutSave();

  return (
    <div>
      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
        }}
      >
        There are unsaved changes that will be lost. Are you sure you want to
        exit this order?
      </Typography>
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <Button
          color="error"
          variant="outlined"
          sx={{ marginRight: "16px", marginBottom: "16px" }}
          onClick={onCancelClose}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          sx={{ marginBottom: "16px" }}
          variant="outlined"
          onClick={onExit}
        >
          Exit without Saving
        </Button>
        <Button color="primary" variant="contained" onClick={onSave}>
          Save and Exit
        </Button>
      </Box>
    </div>
  );
}

ConfirmCloseViewOrder.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onExitAndSaveOrder: PropTypes.func.isRequired,
  onExitWithoutSave: PropTypes.func.isRequired,
};
